<div class="content">
  @if (loaded && organization !== null) {
    <div class="content-body">
      <div class="left">
        <app-organization-update
          [organization]="organization"
          (saved)="onChildSaved($event)"
        ></app-organization-update>

        <app-organization-shopify-sync
          [organization]="organization"
          (saved)="onChildSaved($event)"
        ></app-organization-shopify-sync>
      </div>

      <div class="right">
        <app-product-data-filename-convention-card
          [organizationId]="organization.id!"
        ></app-product-data-filename-convention-card>

        <app-organization-data-convention-section
          [organizationId]="organization.id!"
        ></app-organization-data-convention-section>
      </div>
    </div>

    <div class="content-actions">
      <button mat-stroked-button (click)="goBack()">Cancel</button>
    </div>
  }
</div>
